<template>
   <user-form
      type="edit"
   />
</template>

<script>
import UserForm from '@/components/organisms/Admin/Users/UserForm';

export default {
   name: 'create-user',
   components: {
      UserForm,
   },
}
</script>

<style lang="scss" scoped>
</style>
